import './HallPointsConfigurations.scss';

import { Col, Row } from "react-bootstrap";
import { LeadingActions, SwipeAction, SwipeableList, SwipeableListItem, TrailingActions } from "react-swipeable-list";
import { faAdd, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import AppCard from '../../../commons/cards/AppCard';
import AppLoading from "../../../commons/AppLoading";
import ConfirmModal from '../../../commons/modal/ConfirmModal';
import EmptyState from '../../../commons/EmptyState';
import FloatingButton from "../../../commons/buttons/FloatingButton";
import FloatingVideoButton from '../../../commons/buttons/FloatingVideoButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppToast from "../../../commons/HallAppToast";
import HallPointsAPI from '../HallPointsAPI';
import MenuTitle from '../../../commons/menu/MenuTitle';
import ModalHallPointsConfigurations from "./ModalHallPointsConfigurations";

const hallPointsAPI = new HallPointsAPI();

function HallPointsConfigurations() {
    const [showModalConfig, setShowModalConfig] = useState(false)
    const [configs, setConfigs] = useState([])
    const [isLoading, setIsloading] = useState(true)
    const [selectedConfig, setSelectedConfig] = useState(null)
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false)

    useEffect(() => {
        findAllConfigs()
    }, []);

    const findAllConfigs = async () => {
        try {
            const resp = await hallPointsAPI.fidnAllConfig()
            setConfigs(resp.data)
        } catch (_) {
            HallAppToast.genericError()
            setIsloading(false)
            setConfigs([])
        } finally {
            setIsloading(false)
        }
    }

    const editAction = (config) => (
        <LeadingActions>
            <SwipeAction onClick={() => {
                setSelectedConfig(config);
                setShowModalConfig(true)
            }}>
                <div className="swipe-container-points">
                    <div className="swipe-edit">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                        <div>EDITAR</div>
                    </div>
                </div>
            </SwipeAction>
        </LeadingActions>
    );

    const deleteAction = (config) => (
        <TrailingActions>
            <SwipeAction
                destructive={false}
                onClick={() => {
                    setSelectedConfig(config);
                    setShowModalDelete(true);
                }}
            >
                <div className="swipe-container-points">
                    <div className="swipe-delete">
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                        <div>EXCLUIR</div>
                    </div>
                </div>
            </SwipeAction>
        </TrailingActions>
    );


    const PointsRuleCard = ({ rule }) => {
        return (
            <div style={{ width: '100%' }}>
                <AppCard>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">{rule.name}</h5>
                        <span className={`badge ${rule.status === 'ACTIVE' ? 'bg-success' : 'bg-secondary'}`}>
                            {rule.status === 'ACTIVE' ? 'ATIVO' : 'INATIVO'}
                        </span>
                    </div>

                    <p className="card-text mb-2">
                        <strong>Tipo de Regra:</strong> {formatRuleType(rule.ruleType)}
                    </p>


                    <p className="card-text mb-2">
                        <strong>Pontos:</strong> {rule.point || '--'}
                    </p>

                    {rule.ruleType === 'POINTS_FOR_VALUE' &&
                        <p className="card-text mb-2">
                            <strong>Valor de Referência:</strong> R$ {rule.value?.toFixed(2)}
                        </p>
                    }

                    {rule.ruleType === 'POINTS_FOR_PERCENTAGE' &&
                        <p className="card-text mb-2">
                            <strong>Valor de Referência:</strong> {rule.value}%
                        </p>
                    }

                    <p className="card-text mb-0">
                        <strong>Validade dos Pontos:</strong> {rule.expirationInMonths} mês(es)
                    </p>
                </AppCard>
            </div>
        );
    };

    const formatRuleType = (type) => {
        switch (type) {
            case 'POINTS_FOR_VALUE':
                return 'Pontos por Valor Gasto';
            case 'POINTS_FOR_SERVICE':
                return 'Pontos Fixos por Serviço';
            case 'POINTS_FOR_PERCENTAGE':
                return 'Pontos por Percentual do Valor';
            default:
                return 'Tipo Desconhecido';
        }
    };

    async function executeDeletion() {
        setIsLoadingModalDelete(true)
        try {
            await hallPointsAPI.delete(selectedConfig.id);
            setShowModalDelete(false)
            HallAppToast.success();
            findAllConfigs();
        } catch (_) {
            HallAppToast.genericError();
            setIsLoadingModalDelete(false)
        } finally {
            setIsLoadingModalDelete(false)
        }
    }

    return (
        <div className="container py-5">

            {/* Título da seção */}
            <MenuTitle title="Regras de Pontuação" showArrowInfo={true} />

            {/* Lista de configurações */}
            <Row className="g-4">
                {isLoading ? (
                    <AppLoading />
                ) : (
                    configs.length === 0 ? <EmptyState
                    title="Nenhuma regra de pontuação cadastrada"
                    description="Defina como seus clientes acumulam HallPoints e como podem resgatar benefícios."
                    actionLabel="+ Cadastrar regra de pontuação"
                    onAction={() => setShowModalConfig(true)}
                  /> :
                    configs.map((c) => (
                        <Col xs={12} md={6} lg={4} key={c.id}>
                            <SwipeableList>
                                <SwipeableListItem
                                    leadingActions={editAction(c)}
                                    trailingActions={deleteAction(c)}
                                    fullSwipe={false}
                                >
                                    <PointsRuleCard rule={c} />
                                </SwipeableListItem>
                            </SwipeableList>
                        </Col>
                    ))
                )}
            </Row>

            <FloatingVideoButton youtubeUrl={"https://youtube.com/embed/YiGYq9rAoSk"} />
            {/* Botão flutuante para adicionar */}
            <FloatingButton
                icon={faAdd}
                onClick={() => setShowModalConfig(true)}
                tooltip="Nova Regra"
            />

            {/* Modal de confirmação de exclusão */}
            <ConfirmModal
                show={showModalDelete}
                title="Excluir"
                isLoading={isLoadingModalDelete}
                confirm={executeDeletion}
                closeModal={() => {
                    setShowModalDelete(false);
                    setSelectedConfig(null);
                }}
            >
                Deseja remover a regra <strong>{selectedConfig?.name}</strong>?
            </ConfirmModal>

            {/* Modal de criação/edição de regra */}
            {showModalConfig && (
                <ModalHallPointsConfigurations
                    show={showModalConfig}
                    selectedConfig={selectedConfig}
                    findAllConfigs={findAllConfigs}
                    closeShow={() => {
                        setShowModalConfig(false);
                        setSelectedConfig(null);
                    }}
                />
            )}
        </div>
    );
}

export default HallPointsConfigurations;